module.exports = __webpack_public_path__ + "img/popup.6f140e65.png";